import React from "react";
import {
  useLocation,
  useNavigate,
  useParams,
  Routes,
  Route,
} from "react-router-dom";

import {
  // Analytics,
  // AnalyticsDetails,
  MonitorDrift,
  ModelsWorkbench,
  ModelDetails,
  BookmarksList,
  Model_Comparision,
  ModelRegistrations,
  DataSourceMastersList,
  AlgorithmMasterList,
  DataSourceMastersDetails,
  DriftCalculationWorkbench,
  AlgorithmMasterDetails,
  ServerRegistrationDetails,
  ServerRegistrationList,
  AnalyticsList,
  AnalyticsDetails
} from "../pages";



const AnalyticsRouter = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();
  const propsData = { location, navigate, params };

  const dynamicRouteRender = (routes) => {
    return (
      routes &&
      Array.isArray(routes) &&
      routes.map((route, index) => (
        <Route key={index} {...route} />
      ))
    );
  };
  let routes = [
    { path: '/ModelRegistration', element: <ModelRegistrations {...propsData} /> },
    // { path: '/UseCase', element: <Analytics {...propsData} /> },
    // { path: '/UseCaseDetails/:Id', element: <AnalyticsDetails {...propsData} /> },
    { path: '/ModelsWorkbench', element: <ModelsWorkbench {...propsData} /> },
    { path: '/RegisterModel', element: <ModelDetails {...propsData} /> },
    { path: '/ModelDetails', element: <ModelDetails {...propsData} /> },
    { path: '/ModelDetails/:Id', element: <ModelDetails {...propsData} /> },
    { path: '/ModelComparisionList', element: <BookmarksList {...propsData} /> },
    { path: '/ModelComparision/:Id', element: <Model_Comparision {...propsData} /> },
    { path: '/ModelComparision', element: <Model_Comparision {...propsData} /> },
    { path: '/DriftCalculationWorkbench', element: <DriftCalculationWorkbench {...propsData} /> },
    { path: '/MonitorDrift/:Id', element: <MonitorDrift {...propsData} /> },
    { path: '/MonitorDrift', element: <MonitorDrift {...propsData} /> },
    { path: '/DataSourceMastersList', element: <DataSourceMastersList {...propsData} /> },
    { path: '/DataSourceMastersDetails', element: <DataSourceMastersDetails {...propsData} /> },
    { path: '/DataSourceMastersDetails/:Id', element: <DataSourceMastersDetails {...propsData} /> },
    { path: '/AlgorithmMasterList', element: <AlgorithmMasterList {...propsData} /> },
    { path: '/AlgorithmMasterDetails', element: <AlgorithmMasterDetails {...propsData} /> },
    { path: '/AlgorithmMasterDetails/:Id', element: <AlgorithmMasterDetails {...propsData} /> },
    { path: '/ServerRegistrationList', element: <ServerRegistrationList {...propsData} /> },
    { path: '/ServerRegistrationDetails', element: <ServerRegistrationDetails {...propsData} /> },
    { path: '/ServerRegistrationDetails/:Id', element: <ServerRegistrationDetails {...propsData} /> },
    { path: '/RbsAnalytics/UseCase', element: <AnalyticsList {...propsData}/> },
    { path: '/RbsAnalytics/UseCaseDetails/:id', element: <AnalyticsDetails {...propsData}/>},
  ];
  return (
    <div>
      <Routes>{dynamicRouteRender(routes)}</Routes>
    </div>
  );
};

export default AnalyticsRouter;
